/** Categories shown in the patch-notes panel. */
export type PatchNoteCategory = "gameplay" | "skills";

/** One bullet under Gameplay Updates. */
export interface PatchGameplayEntry {
  /** Player-facing text. Use `\n` for line breaks within one bullet. */
  text: string;
}

/** One change line under a spell (Dota hero-style grouping). */
export interface PatchSkillChange {
  /** Passive / synergy node id from PASSIVE_TREES when the change targets a node. */
  passiveId?: string;
  /** Player-facing text. Use `\n` for line breaks within one block (no row divider). */
  text: string;
}

/** Spell-centric group — like a hero block on dota2.com/patches. */
export interface PatchSpellGroup {
  spellId: string;
  changes: PatchSkillChange[];
}

export interface PatchRelease {
  /** File slug — one per calendar day: `YYYY-MM-DD_01` (legacy days may have `_02`, …). */
  id: string;
  /** Build or semver id (machine-friendly). */
  version: string;
  /** Human-readable release date. */
  date: string;
  /** Git baseline for the *next* notes run. */
  sinceCommit?: string;
  gameplay: PatchGameplayEntry[];
  skills: PatchSpellGroup[];
}

export const PATCH_NOTE_CATEGORY_LABELS: Record<PatchNoteCategory, string> = {
  gameplay: "Gameplay Updates",
  skills: "Skill Updates",
};

/** Sort key so newest release id sorts first (`2026-06-07_02` > `2026-06-07_01`). */
export function releaseSortKey(id: string): string {
  const m = id.match(/^(\d{4}-\d{2}-\d{2})_(\d{2})$/);
  if (!m) return id;
  return `${m[1]}-${m[2]}`;
}
